
import { Vue, Component, Prop } from 'vue-property-decorator';
import TopBar from '@/components/TopBar.vue';
import IntakeChart from '@/components/IntakeChart.vue';
import { postResult } from '@/utils/resultPoster';
import {Intake, MutationType, RouteName} from '@/enums';
import { getIntake, getRecommendedIntake, getIntakeResult } from '@/utils/resultUtil';
import { ProductInput, PortionData, IntakeAmount, IntakeResult } from '@/types';
import store from '@/store';
import { t } from '@/utils';
import {isVariationDiet, isVariationMunicipality} from "@/utils/common";

@Component({
	components: {
		TopBar,
		IntakeChart
	}
})
export default class Result extends Vue {
	private solidsOverThreshold:boolean = false;
	private liquidsOverThreshold:boolean = false;
	private childAge:number | null = 0;

	private portionsSolids:number = 4; // Solids PLUS liquids
	private portionsLiquids:number = 2;

	private portionsSolidsWeekly:number = 4;  // Solids PLUS liquids
	private portionsLiquidsWeekly:number = 1;
	private portionsLiquidsSize:number = 250;

	private intake!: IntakeAmount;
	private recommendedIntake!: IntakeAmount;
	private result!: IntakeResult;

	private isVariationDiet: boolean = isVariationDiet();

	private intakePercent:number = 0;
	private intakeRecommendedPercent:number = 0;

	private summaryMessage:string = '';

	mounted() {
		let endTime: Date = new Date();
		store.commit(MutationType.SET_SESSION_DURATION_END_TIME, endTime);

		this.intake = getIntake();
		this.recommendedIntake = getRecommendedIntake(this.intake);
		this.result = getIntakeResult();

		this.portionsSolidsWeekly = this.recommendedIntake[Intake.FOOD_PORTIONS];
		this.portionsLiquidsWeekly = this.recommendedIntake[Intake.DRINKS_PORTIONS];

		console.log('recommendedIntake', this.recommendedIntake, this.childAge);
		this.solidsOverThreshold = this.intake[Intake.FOOD_PORTIONS] > this.recommendedIntake[Intake.FOOD_PORTIONS];
		this.liquidsOverThreshold = this.intake[Intake.DRINKS_PORTIONS] > this.recommendedIntake[Intake.DRINKS_PORTIONS];

		this.portionsSolids = this.intake[Intake.FOOD_PORTIONS];
		this.portionsLiquids = this.intake[Intake.DRINKS_PORTIONS];

		this.childAge = store.state.userAge ;

		this.portionsLiquidsSize = this.recommendedIntake[Intake.DRINKS];

		let portionsIntakeRecommended = this.recommendedIntake[Intake.FOOD_PORTIONS] + this.recommendedIntake[Intake.DRINKS_PORTIONS];
		let portionsIntakeTotal = this.intake[Intake.FOOD_PORTIONS] + this.intake[Intake.DRINKS_PORTIONS];

		this.intakeRecommendedPercent = 5;

		// The chart framework can't show 100%
		this.intakePercent = Math.min(99.99, Math.max(0, (portionsIntakeTotal / portionsIntakeRecommended) * this.intakeRecommendedPercent));
		//
		// console.log('this.portionsIntakeRecommended', portionsIntakeRecommended);
		// console.log('this.portionsIntakeTotal', portionsIntakeTotal);
		// console.log('this.intakePercent', this.intakePercent);
		// console.log('this.solidsOverThreshold', this.solidsOverThreshold);
		// console.log('this.intake[Intake.FOOD]', this.intake[Intake.FOOD_PORTIONS], this.recommendedIntake[Intake.FOOD_PORTIONS]);
		// console.log('this.intake[Intake.DRINKS]', this.intake[Intake.DRINKS_PORTIONS], this.recommendedIntake[Intake.DRINKS_PORTIONS]);
		// console.log('this.liquidsOverThreshold', this.liquidsOverThreshold);

		if (this.solidsOverThreshold && this.liquidsOverThreshold) {
			// Both over
			this.summaryMessage = t('intake', 'intakeEverythingOverThreshold');
		} else if (this.solidsOverThreshold) {
			// Solids over
			this.summaryMessage = t('intake', 'intakeSolidsOverThreshold');
		} else if (this.liquidsOverThreshold) {
			// Liquids over
			this.summaryMessage = t('intake', 'intakeLiquidsOverThreshold');
		} else {
			// Everything OK
			this.summaryMessage = t('intake', 'intakeEverythingUnderThreshold');
		}

		if (isVariationMunicipality()) {
			postResult();
		}
	}

	private formatPortions(portions:number) : string {
		return portions.toString().replace('.', ',');
	}

	private dynamicTranslate(category:string, message:string, params:Array<string> = []) : string {
		let translatedMessage = t(category, message);
		let originalMessage = translatedMessage;

		const poorMansHtmlEscapeTable:any = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			"'": '&#39;',
			'"': '&quot;'
		};

		// Replace HTML content that isn't in variables
		translatedMessage = translatedMessage.replace(/[&<>'"]/g, (match:string) : string => {
			return poorMansHtmlEscapeTable.hasOwnProperty(match) ? poorMansHtmlEscapeTable[match] : match;
		});

		// Replace variables with param span elements
		translatedMessage = translatedMessage.replace(/\{(\d+)\}/g, (paramString:string, paramNumber:number) : string => {
			let paramValue:string = paramString;

			if (params.hasOwnProperty(paramNumber)) {
				paramValue = params[paramNumber].toString().replace(/[&<>'"]/g, (match:string) : string => {
					return poorMansHtmlEscapeTable.hasOwnProperty(match) ? poorMansHtmlEscapeTable[match] : match;
				});
			}

			return `<span class="param param-${paramNumber}">${paramValue}</span>`;
		});

		return translatedMessage;
	}

	private saveResult(): void {}

	private printResult() : void {
		window.print();
	}

	private replay() : void {
		this.$store.commit(MutationType.RESET_STORE);

		this.$router.push({
			name: RouteName.HOME
		});
	}
}
